export default {"src":"/_next/static/media/chevronDownGrey.c4a63425.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};